import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle as MuiDialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DialogTitle = (props) => {
  const { children, onClose, data, ...other } = props;
  return (
    <MuiDialogTitle sx={{ margin: 0, padding: 2 }} {...other}>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs>
          <Typography variant="h6">{children}</Typography>
        </Grid>
        <Grid item>
          {onClose ? (
            <IconButton aria-label="close" sx={{ color: "grey.500" }} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          ) : null}
        </Grid>
      </Grid>
    </MuiDialogTitle>
  );
};

export default function ConfirmationDialog(props) {
  const [content, setContent] = useState(null);

  const handleClose = () => {
    props?.handleOpen(null);
  };

  const handleAction = () => {
    content && content.confirmAction();
    handleClose();
  };

  useEffect(() => {
    setContent(props.content);
  }, [props.content]);

  return (
    <>
      {content && (
        <Dialog
          fullWidth
          open={Boolean(content)}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{content.title ? content.title : ""}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{content.text ? content.text : ""}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              color="secondary"
              variant="contained"
              disabled={!content.confirmAction}
              onClick={handleAction}
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
